<template>
    <div class="opui-row">
        <div class="opui-col">
            <RichSelect
                v-model="item.settings.membership_id"
                modelValue="item.settings.membership_id"
                :settings="{ ajax: { url: this.restUrl('flow/memberships?vendor=wishlist'), dataType: 'json' } }"
                :ajaxUrl="restUrl('flow/memberships?vendor=wishlist')"
                :placeholder="'Select membership'"
                @select="membershipChange"
                :required="true"
            >
                <option :value="item.settings.membership_id" selected :key="item.settings.membership_id" v-if="item.settings && item.settings.membership_id">
                    {{ item.settings.membership_title ? item.settings.membership_title : item.settings.membership_id }}
                </option>
            </RichSelect>
        </div>
    </div>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"

export default {
    components: { RichSelect },
    props: {
        workflow: { type: Object, required: true },
        item:     { type: Object, required: true }
    },
    data() {
        return {
            membership: [],
        }
    },
    mounted() {
        this.validate()
    },
    methods: {
        membershipChange(selected) {
            this.item.settings.membership_title = selected.text
            this.validate()
        },

        validate() {
            if (this.item.settings.membership_id) {
                this.item.validated = true
            } else {
                this.item.validated = false
            }
        }
    }
}
</script>
